import { LoadingStates } from '@pb/utils'
import { createReducer } from 'redux-act'

import { VoucherState } from '../types'
import * as actions from './actions'
import initialState from './initialState'

const reducer = createReducer<VoucherState>({}, initialState)

reducer.on(actions.setAppliedVouchers, (state, appliedVouchers) => ({
  ...state,
  appliedVouchers,
}))

reducer.on(actions.getConfiguredOffersStart, (state) => ({
  ...state,
  getConfiguredOffersStatus: LoadingStates.Loading,
}))

reducer.on(actions.getConfiguredOffersSuccess, (state, configuredOffers) => ({
  ...state,
  configuredOffers,
  getConfiguredOffersStatus: LoadingStates.LoadedSuccess,
}))

reducer.on(actions.getConfiguredOffersFail, (state) => ({
  ...state,
  getConfiguredOffersStatus: LoadingStates.LoadedFail,
}))

reducer.on(actions.getVouchersStart, (state) => ({
  ...state,
  getVouchersStatus: LoadingStates.Loading,
  errors: [],
}))

reducer.on(actions.getVouchersSuccess, (state, offers) => ({
  ...state,
  offers,
  getVouchersStatus: LoadingStates.LoadedSuccess,
}))

reducer.on(actions.getVouchersFail, (state, error) => ({
  ...state,
  getVouchersStatus: LoadingStates.LoadedFail,
  errors: [error],
}))

reducer.on(actions.postVouchersStart, (state) => ({
  ...state,
  postVouchersStatus: LoadingStates.Loading,
  errors: [],
}))

reducer.on(actions.postVouchersSuccess, (state, { appliedVouchers, unAppliedVouchers }) => ({
  ...state,
  appliedVouchers,
  unAppliedVouchers,
  postVouchersStatus: LoadingStates.LoadedSuccess,
}))

reducer.on(actions.postVouchersFail, (state, error) => ({
  ...state,
  postVouchersStatus: LoadingStates.LoadedFail,
  errors: [error],
}))

reducer.on(actions.deleteVouchersStart, (state) => ({
  ...state,
  deleteVouchersStatus: LoadingStates.Loading,
  errors: [],
}))

reducer.on(actions.deleteVouchersSuccess, (state, { appliedVouchers, unAppliedVouchers }) => ({
  ...state,
  appliedVouchers,
  unAppliedVouchers,
  deleteVouchersStatus: LoadingStates.LoadedSuccess,
}))

reducer.on(actions.deleteVouchersFail, (state, error) => ({
  ...state,
  deleteVouchersStatus: LoadingStates.LoadedFail,
  errors: [error],
}))

reducer.on(actions.storeDeletedVouchers, (state, voucherCode) => ({
  ...state,
  deletedVouchers: [...state.deletedVouchers, voucherCode],
}))

reducer.on(actions.clearStoredDeletedVouchers, (state) => ({
  ...state,
  deletedVouchers: [],
}))

reducer.on(actions.clearErrors, (state) => ({
  ...state,
  errors: [],
}))

reducer.on(actions.setLastAppliedUnavailableVoucher, (state, unAppliedVoucher) => ({
  ...state,
  lastAppliedUnavailableVoucher: unAppliedVoucher,
}))

reducer.on(actions.setPostingVoucherWithCode, (state, voucherCode) => ({
  ...state,
  postingVoucherWithCode: voucherCode,
}))

export default reducer
